import { getTeamsState } from '../selectors';

export const getTeamDetailsState = state => getTeamsState(state).details;
export const getTeamDetails = state => getTeamDetailsState(state).data;
